export const selfAssessmentEntity = {
  selfAssessment_humanResources_totalNumberStaff_men: null,
  selfAssessment_humanResources_totalNumberStaff_women: null,
  selfAssessment_humanResources_totalStaff_men: null,
  selfAssessment_humanResources_totalStaff_women: null,
  selfAssessment_staff_byDemographics_age_total_men: null,
  selfAssessment_staff_byDemographics_age_total_women: null,
  selfAssessment_staff_department_service_women: null,
  selfAssessment_staff_department_total_men: null,
  selfAssessment_staff_department_total_women: null,
  selfAssessment_staff_responsibility_management_subtotal_men: null,
  selfAssessment_staff_responsibility_management_subtotal_women: null,
  selfAssessment_staff_responsibility_otherPositions_subtotal_men: null,
  selfAssessment_staff_responsibility_otherPositions_subtotal_women: null,
  selfAssessment_staff_responsibility_total_men: null,
  selfAssessment_staff_responsibility_total_women: null,
  selfAssessment_staff_department_technical_women: null,
  selfAssessment_employmentPolicies_internalCommunication_q1_inclusiveLanguage:
    null,
  selfAssessment_employmentPolicies_internalCommunication_q2_accesibility:
    null,
  selfAssessment_employmentPolicies_internalCommunication_q3_commitment:
    null,
  selfAssessment_employmentPolicies_internalCommunication_q4_criteriaOfEquality:
    null,
  selfAssessment_employmentPolicies_externalCommunication_q5_inclusiveLanguage:
    null,
  selfAssessment_employmentPolicies_externalCommunication_q6_commitment:
    null,
  selfAssessment_employmentPolicies_externalCommunication_q7_nontraditionalGenderRoles:
    null,
  selfAssessment_employmentPolicies_externalCommunication_q8_criteriaOfEquality:
    null,
  selfAssessment_employmentPolicies_recruitment_q9_promotion: null,
  selfAssessment_employmentPolicies_recruitment_q10_aimForWomenToBalance:
    null,
  selfAssessment_employmentPolicies_recruitment_q11_inclusiveLanguage:
    null,
  selfAssessment_employmentPolicies_recruitment_q12_formalProcess: null,
  selfAssessment_employmentPolicies_recruitment_q13_jobsReservedforWomen:
    null,
  selfAssessment_employmentPolicies_recruitment_q14_jobsReservedforMen:
    null,
  selfAssessment_employmentPolicies_recruitment_q15_equalOpportunities:
    null,
  selfAssessment_employmentPolicies_recruitment_q16_prohibitDiscrimination:
    null,
  selfAssessment_employmentPolicies_recruitment_q17_processEqualForMenWomen:
    null,
  selfAssessment_employmentPolicies_promotion_q18_fairAssessments: null,
  selfAssessment_employmentPolicies_promotion_q19_PromotionWithoutGenderBias:
    null,
  selfAssessment_employmentPolicies_promotion_q20_internalPolicy: null,
  selfAssessment_employmentPolicies_promotion_q21_concreteObjectivesMobility:
    null,
  selfAssessment_employmentPolicies_promotion_q22_EnsureMenWomenAccessPromotions:
    null,
  selfAssessment_employmentPolicies_promotion_q23_EnsureEqualRepresentation:
    null,
  selfAssessment_employmentPolicies_promotion_q24_careerPaths: null,
  selfAssessment_employmentPolicies_promotion_q25_criteriaOfEquality:
    null,
  selfAssessment_employmentPolicies_training_q26_consistencyWithNeedsIdentified:
    null,
  selfAssessment_employmentPolicies_training_q27_specificObjectivesOnGenderEquity:
    null,
  selfAssessment_employmentPolicies_training_q28_EnsureMenWomenAccessTraining:
    null,
  selfAssessment_employmentPolicies_training_q29_verficationOfTraining:
    null,
  selfAssessment_employmentPolicies_training_q30_accessForNontraditionalPositions:
    null,
  selfAssessment_employmentPolicies_training_q31_interferenceWithFamily:
    null,
  selfAssessment_employmentPolicies_training_q32_annualTrainings: null,
  selfAssessment_employmentPolicies_training_q33_criteriaOfEquality: null,
  selfAssessment_employmentPolicies_wages_q34_ensureEqualPay: null,
  selfAssessment_employmentPolicies_wages_q35_transparentInformation:
    null,
  selfAssessment_employmentPolicies_wages_q36_implementationOfEqualPay:
    null,
  selfAssessment_employmentPolicies_wages_q37_criteriaForAssigningSalary:
    null,
  selfAssessment_employmentPolicies_wages_q38_fairWagePolicy: null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q39_informationExplicitProhibition:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q40_institutionalPolicy:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q41_annualTraining:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q42_responsiblesForMeasures:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q43_monitoringAndFollowing:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q44_awareness:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q45_documentedProcedures:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q46_trackOfComplaints:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q47_annualAwareness:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q48_staffAwareness:
    null,
  selfAssessment_employmentPolicies_preventionSexualHarassment_q49_mechanismEffectiveness:
    null,
  selfAssessment_employmentPolicies_wlbs_q50_womanQuitJobDueBirthOrFamily:
    null,
  selfAssessment_employmentPolicies_wlbs_q51_benefitsOfMaternity: null,
  selfAssessment_employmentPolicies_wlbs_q52_workersFamilyAndPersonalNeeds:
    null,
  selfAssessment_employmentPolicies_wlbs_q53_promotionOfCoparenting: null,
  selfAssessment_employmentPolicies_wlbs_q54_supportForCareServicesChildrenOthers:
    null,
  selfAssessment_employmentPolicies_wlbs_q55_flexibleWorking: null,
  selfAssessment_employmentPolicies_wlbs_q56_worklifeBalance: null,
  selfAssessment_employmentPolicies_wlbs_q57_absencesWithinWorkingHours:
    null,
  selfAssessment_employmentPolicies_wlbs_q58_worklifeBalancePolicies:
    null,
  selfAssessment_employmentPolicies_wlbs_q59_staffAwarenessWorklifeMeasures:
    null,
  selfAssessment_general_classification_market_local: null,
  selfAssessment_general_financialReturn_roe: null,
  selfAssessment_staff_responsibility_management_executiveDirector_women:
    null,
  selfAssessment_general_classification_market_national: null,
  selfAssessment_general_financialReturn_roic: null,
  selfAssessment_general_financialReturn_rois: null,
  selfAssessment_staff_responsibility_management_director_women: null,
  selfAssessment_staff_responsibility_management_executiveDirector_men:
    null,
  selfAssessment_staff_responsibility_management_director_men: null,
  selfAssessment_staff_responsibility_management_middleLevel4_women: null,
  selfAssessment_staff_responsibility_management_middleLevel4_men: null,
  selfAssessment_staff_responsibility_management_middleLevel3_women: null,
  selfAssessment_staff_responsibility_management_middleLevel3_men: null,
  selfAssessment_staff_responsibility_management_middleLevel2_women: null,
  selfAssessment_staff_responsibility_management_middleLevel2_men: null,
  selfAssessment_staff_responsibility_management_middleLevel1_women: null,
  selfAssessment_staff_responsibility_management_middleLevel1_men: null,
  selfAssessment_staff_responsibility_otherPositions_technical_women:
    null,
  selfAssessment_staff_responsibility_otherPositions_technical_men: null,
  selfAssessment_staff_responsibility_otherPositions_administrative_women:
    null,
  selfAssessment_staff_responsibility_otherPositions_administrative_men:
    null,
  selfAssessment_staff_responsibility_otherPositions_support_women: null,
  selfAssessment_staff_responsibility_otherPositions_suport_men: null,
  selfAssessment_staff_responsibility_otherPositions_operational_women:
    null,
  selfAssessment_staff_responsibility_otherPositions_operational_men:
    null,
  selfAssessment_staff_department_administration_women: null,
  selfAssessment_staff_department_administration_men: null,
  selfAssessment_staff_department_commercial_women: null,
  selfAssessment_staff_department_commercial_men: null,
  selfAssessment_staff_department_logistics_women: null,
  selfAssessment_staff_department_logistics_men: null,
  selfAssessment_staff_department_production_women: null,
  selfAssessment_staff_department_production_men: null,
  selfAssessment_staff_department_service_men: null,
  selfAssessment_staff_department_technical_men: null,
  selfAssessment_staff_department_humanResources_women: null,
  selfAssessment_staff_department_humanResources_men: null,
  selfAssessment_staff_board_women: null,
  selfAssessment_staff_board_men: null,
  selfAssessment_staff_byDemographics_age_under18_women: null,
  selfAssessment_staff_byDemographics_age_under18_men: null,
  selfAssessment_staff_byDemographics_age_between18And30_women: null,
  selfAssessment_staff_byDemographics_age_between18And30_men: null,
  selfAssessment_staff_byDemographics_age_between31And60_women: null,
  selfAssessment_staff_byDemographics_age_between31And60_men: null,
  selfAssessment_staff_byDemographics_age_older60_women: null,
  selfAssessment_staff_byDemographics_age_older60_men: null,
  selfAssessment_staff_byDemographics_disability_yes_women: null,
  selfAssessment_staff_byDemographics_disability_yes_men: null,
  selfAssessment_staff_byDemographics_disability_no_women: null,
  selfAssessment_staff_byDemographics_disability_no_men: null,
  selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_women:
    null,
  selfAssessment_staff_byDemographics_ethnicIdentity_afrodescendant_men:
    null,
  selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_women:
    null,
  selfAssessment_staff_byDemographics_ethnicIdentity_indigenous_men: null,
  selfAssessment_staff_byDemographics_ethnicIdentity_nonAfroNonIndigenous_women:
    null,
  selfAssessment_staff_byDemographics_ethnicIdentity_nonAfroNonIndigenous_men:
    null,
  selfAssessment_staff_byDemographics_ethnicIdentity_afroAndIndigenous_women:
    null,
  selfAssessment_staff_byDemographics_ethnicIdentity_afroAndIndigenous_men:
    null,
  selfAssessment_staff_byDemographics_seniority_less2_women: null,
  selfAssessment_staff_byDemographics_seniority_less2_men: null,
  selfAssessment_staff_byDemographics_seniority_between2And5_women: null,
  selfAssessment_staff_byDemographics_seniority_between2And5_men: null,
  selfAssessment_staff_byDemographics_seniority_between5And10_women: null,
  selfAssessment_staff_byDemographics_seniority_between5And10_men: null,
  selfAssessment_staff_byDemographics_seniority_more10_women: null,
  selfAssessment_staff_byDemographics_seniority_more10_men: null,
  selfAssessment_staff_byDemographics_genderIdentity_womenMen_women: null,
  selfAssessment_staff_byDemographics_genderIdentity_womenMen_men: null,
  selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_women:
    null,
  selfAssessment_staff_byDemographics_genderIdentity_transgenderMen_men:
    null,
  selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_women:
    null,
  selfAssessment_staff_byDemographics_genderIdentity_transgenderWomen_men:
    null,
  selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_women:
    null,
  selfAssessment_staff_byDemographics_genderIdentity_genderNonConforming_men:
    null,
  selfAssessment_staff_byDemographics_genderIdentity_other_women: null,
  selfAssessment_staff_byDemographics_genderIdentity_other_men: null,
  selfAssessment_staff_byDemographics_genderIdentity_other_description:
    "",
  selfAssessment_laborConditions_contract_full_permanent_women: null,
  selfAssessment_laborConditions_contract_full_subtotal_men: null,
  selfAssessment_laborConditions_contract_full_subtotal_women: null,
  selfAssessment_laborConditions_contract_part_subtotal_men: null,
  selfAssessment_laborConditions_contract_part_subtotal_women: null,
  selfAssessment_laborConditions_contract_full_permanent_men: null,
  selfAssessment_laborConditions_contract_full_temporary_women: null,
  selfAssessment_laborConditions_contract_full_temporary_men: null,
  selfAssessment_laborConditions_contract_part_permanent_women: null,
  selfAssessment_laborConditions_contract_part_permanent_men: null,
  selfAssessment_laborConditions_contract_part_temporary_women: null,
  selfAssessment_laborConditions_contract_part_temporary_men: null,
  selfAssessment_laborConditions_wages_executiveDirector_women: null,
  selfAssessment_laborConditions_wages_executiveDirector_men: null,
  selfAssessment_laborConditions_wages_management_women: null,
  selfAssessment_laborConditions_wages_management_men: null,
  selfAssessment_laborConditions_wages_middleLevel4_women: null,
  selfAssessment_laborConditions_wages_middleLevel4_men: null,
  selfAssessment_laborConditions_wages_middleLevel3_women: null,
  selfAssessment_laborConditions_wages_middleLevel3_men: null,
  selfAssessment_laborConditions_wages_middleLevel2_women: null,
  selfAssessment_laborConditions_wages_middleLevel2_men: null,
  selfAssessment_laborConditions_wages_middleLevel1_women: null,
  selfAssessment_laborConditions_wages_middleLevel1_men: null,
  selfAssessment_laborConditions_wages_technical_women: null,
  selfAssessment_laborConditions_wages_technical_men: null,
  selfAssessment_laborConditions_wages_administrative_women: null,
  selfAssessment_laborConditions_wages_administrative_men: null,
  selfAssessment_laborConditions_wages_support_women: null,
  selfAssessment_laborConditions_wages_support_men: null,
  selfAssessment_laborConditions_wages_operational_women: null,
  selfAssessment_laborConditions_wages_operational_men: null,
  selfAssessment_laborConditions_workingParents_noWorkingParents_women:
    null,
  selfAssessment_laborConditions_workingParents_noWorkingParents_men:
    null,
  selfAssessment_laborConditions_workingParents_noSingleParents_women:
    null,
  selfAssessment_laborConditions_workingParents_noSingleParents_men: null,
  selfAssessment_laborConditions_leavePolicies_paternity_policyExists: true,
  selfAssessment_laborConditions_leavePolicies_maternity_policyExists: true,
  selfAssessment_laborConditions_leavePolicies_breastfeeding_policyExists: true,
  selfAssessment_laborConditions_leavePolicies_reductionWorkingHours_policyExists: true,
  selfAssessment_laborConditions_leavePolicies_permittedLeave_policyExists: true,
  selfAssessment_laborConditions_leavePolicies_elegible_paternity_men:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men:
    null,
  selfAssessment_laborConditions_leavePolicies_elegible_maternity_women:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women:
    null,
  selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_women:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women:
    null,
  selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_women:
    null,
  selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_men:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men:
    null,
  selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_women:
    null,
  selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_men:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women:
    null,
  selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men:
    null,
  selfAssessment_laborConditions_leavePolicies_other: null,
  selfAssessment_laborConditions_flexTime_other: null,
  selfAssessment_laborConditions_flexTime_flexibitilityArrivalDeparture_policyExists: true,
  selfAssessment_laborConditions_flexTime_NegotiatedShedule_policyExists: true,
  selfAssessment_laborConditions_flexTime_reductionHours_policyExists: true,
  selfAssessment_laborConditions_flexTime_paidLeave_policyExists: true,
  selfAssessment_laborConditions_flexTime_unpaidLeave_policyExists: true,
  selfAssessment_laborConditions_flexTime_telecommuting_policyExists: true,
  selfAssessment_laborConditions_flexTime_transportationResidence_policyExists: true,
  selfAssessment_laborConditions_flexTime_childCareAtCompany_policyExists: true,
  selfAssessment_laborConditions_flexTime_externalChildCare_policyExists: true,
  selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_reductionHours_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_reductionHours_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_paidLeave_women: null,
  selfAssessment_laborConditions_flexTime_elegible_paidLeave_men: null,
  selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_men: null,
  selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_men: null,
  selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_telecommuting_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_telecommuting_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_transportationResidence_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_transportationResidence_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_men:
    null,
  selfAssessment_laborConditions_flexTime_elegible_externalChildCare_women:
    null,
  selfAssessment_laborConditions_flexTime_elegible_externalChildCare_men:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_women:
    null,
  selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_men:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_women:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_men:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_women:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_men:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionRecruitment_women:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionRecruitment_men:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionPromotion_women:
    null,
  selfAssessment_laborConditions_preventingSexualHarassment_specificAttentionPromotion_men:
    null,
  selfAssessment_humanResources_absences_annualDaysAgreed: null,
  selfAssessment_humanResources_absences_totalWorkDays_men: null,
  selfAssessment_humanResources_absences_totalWorkDays_women: null,
  selfAssessment_humanResources_absences_totalLostDays_women: null,
  selfAssessment_humanResources_absences_totalLostDays_men: null,
  selfAssessment_humanResources_absenceDueStoppage_women: null,
  selfAssessment_humanResources_absenceDueStoppage_men: null,
  selfAssessment_humanResources_returningAfterMaternityLeave_took: null,
  selfAssessment_humanResources_returningAfterMaternityLeave_didNotReturn:
    null,
  selfAssessment_humanResources_returningAfterMaternityLeave_return: null,
  selfAssessment_humanResources_staffing_applicants_women: null,
  selfAssessment_humanResources_staffing_applicants_men: null,
  selfAssessment_humanResources_staffing_newHires_women: null,
  selfAssessment_humanResources_staffing_newHires_men: null,
  selfAssessment_humanResources_internalPromotions_nominated_women: null,
  selfAssessment_humanResources_internalPromotions_nominated_men: null,
  selfAssessment_humanResources_internalPromotions_promoted_women: null,
  selfAssessment_humanResources_internalPromotions_promoted_men: null,
  selfAssessment_humanResources_education_receivingTraining_women: null,
  selfAssessment_humanResources_education_receivingTraining_men: null,
  selfAssessment_humanResources_education_trainingHours_women: null,
  selfAssessment_humanResources_education_trainingHours_men: null,
  selfAssessment_general_financialReturn_revenue: null,
  selfAssessment_general_financialReturn_netIncome: null,
  selfAssessment_general_financialReturn_ebitda: null,
}
